$().ready(function () {
  
$('.sizebox').on('input',function(){
  var lgt = $("#lgt").val(),wdt = $("#wdt").val();
  console.log(lgt,wdt);
  var dty;

  var sqm = (lgt*wdt).toFixed(2);

  var gl = Math.ceil(lgt/0.5), gw = Math.ceil(wdt/0.5);
  var grids = gl*gw;
  var coverage = (grids/4).toFixed(2);

  $('#sqm').html(sqm);
  $('#grids').html(grids);
  $('#coverage').html(coverage);
  $('input[name="quantity"]').val(grids);
});

  $('.atb').click(function(){
    $('.product-form__cart-submit').trigger('click');
  })
});
